import { observable } from 'mobx';

import { RenderedServiceList } from '@store/RenderedService/RenderedServiceList';
import { RenderedServicesEntriesList } from '@dashboard/ui/pages/RenderedServicesPage/store/RenderedServicesEntriesList';

export class RenderedServicesPageStore {
    public static Name = 'renderedServicesPageStore' as const;

    @observable public myRenderedServices = new RenderedServiceList();
    @observable public renderedServicesEntries = new RenderedServicesEntriesList();
    @observable public guaranteeRenderedServices = new RenderedServiceList();
}

export const renderedServicesPageStore = new RenderedServicesPageStore();
